<template>
  <a-layout-footer style="background-color: #fff; padding: 12px 24px;">
    <span>
        <small>
            <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">京ICP备19033266</a>
            &nbsp;&copy {{year}}&nbsp;
            <a href="https://along.ai/" target="_blank">仝睿科技</a>&nbsp;
            <a href="/user/ua" target="_blank">用户协议</a>
        </small>
    </span>
  </a-layout-footer>
</template>

<script>
  export default {
    name: "GlobalFooter",
    data() {
      return {
        year: (new Date()).getFullYear()
      }
    }
  }
</script>

<style>
</style>
